<template>
  <v-card>
    <SuppliersFields
      ref="supplierForm"
      v-bind.sync="supplier"
      :valid.sync="valid"
    ></SuppliersFields>
    <v-card-actions>
      <v-row justify="end" no-gutters>
        <v-btn
          color="primary"
          :disabled="!valid"
          @click="addSupplier"
          :block="$vuetify.breakpoint.xsOnly"
          :large="$vuetify.breakpoint.smAndDown"
        >
          <v-icon left>add</v-icon>Ajouter le fournisseur
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import SuppliersFields from "./SuppliersFields";
export default {
  name: "SuppliersInput",
  components: {
    SuppliersFields
  },
  computed: {
    ...mapGetters(["getOrganisationId"])
  },
  data() {
    return {
      supplier: {
        name_fournisseur: null,
        adresse: null,
        courriel: null,
        telephone: null
      },
      valid: false
    };
  },
  methods: {
    async addSupplier() {
      try {
        this.$store.dispatch("startLoadingOverlay");
        const data = {
          ...this.supplier,
          organisation: this.getOrganisationId
        };
        await this.$store.dispatch("addSupplier", data);
        this.$refs.supplierForm.reset();
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
